export const TutoriaisKeys = {
    CHAT: 'chat',
    DIALOGO: 'dialogo',
    CAMPANHA_MENSAGEM: 'campanhaMensagem',
    MENSAGEM_PROGRAMADA: 'mensagemProgramada',
    IA_AGENTE: 'iaAgente',
} as const

export type TutorialDef = {
    titulo: string
    ytId: string
    ytSi: string
}

/**
 * Registro único dos tutoriais disponíveis. Serve tanto ao componente que exibe
 * o vídeo quanto à conquista "Instruído", que compara o total de tutoriais
 * assistidos pelo usuário com o total existente aqui.
 */
export const tutoriais: Record<string, TutorialDef> = {
    [TutoriaisKeys.CHAT]: {
        titulo: 'Atendimento',
        ytId: 'hUS2Jz3Vqa0',
        ytSi: 'yWs7_W975vO_XPYB',
    },
    [TutoriaisKeys.DIALOGO]: {
        titulo: 'Fluxos de diálogo',
        ytId: '_xDXAknzryc',
        ytSi: 'qQhjG4GIZCSv7Pai',
    },
    [TutoriaisKeys.CAMPANHA_MENSAGEM]: {
        titulo: 'Campanhas de mensagem',
        ytId: 'aZkxt19b51Q',
        ytSi: '2ETUQCiLd1g3X4N_',
    },
    [TutoriaisKeys.MENSAGEM_PROGRAMADA]: {
        titulo: 'Mensagens programadas',
        ytId: 'G-Qs6GmCyRI',
        ytSi: 'ZLG78jnElEPJBKvl',
    },
    [TutoriaisKeys.IA_AGENTE]: {
        titulo: 'Agentes de IA',
        ytId: 'Vj0r2Fvd9iw',
        ytSi: 'TNP8Sp4Pmmvey314',
    },
}

export const totalTutoriais = Object.keys(tutoriais).length
